module.exports = __webpack_public_path__ + "static/media/ic_hide.bd697cfe.svg";